import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const MenuMinisiteIcon = React.forwardRef((props, ref) => (
  <SvgIcon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      id="Path"
      d="M2,0A2,2,0,0,0,0,2V5A2,2,0,0,0,2,7H5A2,2,0,0,0,7,5V2A2,2,0,0,0,5,0Z"
    />
    <path
      id="Path-2"
      d="M11,0A2,2,0,0,0,9,2V5a2,2,0,0,0,2,2h3a2,2,0,0,0,2-2V2a2,2,0,0,0-2-2Z"
    />
    <path
      id="Path-3"
      d="M0,11A2,2,0,0,1,2,9H5a2,2,0,0,1,2,2v3a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2Z"
    />
    <path
      id="Path-4"
      d="M11,9a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h3a2,2,0,0,0,2-2V11a2,2,0,0,0-2-2Z"
    />
  </SvgIcon>
));

export default React.memo(MenuMinisiteIcon);
